import { useRef, useState } from "react";
import DefaultLayout from "app/layouts/DefaultLayout";
import Api from "app/services/api";

function ExaminationResultUploadPage() {
  // input file ref
  const inputTypeFileReference = useRef(null);

  const [isUploading, setIsUploading] = useState(false);

  const ButtonClicked = () => {
    if (isUploading) return;
    inputTypeFileReference.current?.click();
  };

  // choose csv file method:
  const handleSelectCSVFile = async (event) => {
    const csvFileFromLocal = event.target.files?.[0];
    if (!csvFileFromLocal) return;

    const formData = new FormData();
    formData.append("file", csvFileFromLocal);

    
    try {
      setIsUploading(true);

      // call API:
      const data = await Api.examinationDatas.importCSVFileApi(formData);
        
      if (data.status === 201) {
        const lineError = data.data.result.line_error;
        let afterImportMsg =
          "頭皮データ結果\n" +
          data.data.result.dataCount +
          "件登録成功しました\n";

        afterImportMsg +=
          lineError.length === 0 ? "" : lineError.length + "件登録失敗しました";

        if (data.data.result.invalidDataCount > 0) {
          afterImportMsg =
            "登録されていないID、もしくは、到着処理が完了していないIDが含まれています。";
        }

        alert(afterImportMsg);
      } else {
      }

    } catch (error) {
      alert("CSVアップロードに失敗しました。");
    } finally {
      setIsUploading(false);
    }
  };

  return (
    <>
      <DefaultLayout
        headerProps={{
          headerClassName: "md:!block",
          pageTitle: "頭皮データ新規登録",
        }}
      >
        <p>ファイルのアップロード</p>

        <button
          className="border border-black rounded-sm py-2 px-2 m-auto disabled:opacity-50"
          onClick={ButtonClicked}
          disabled={isUploading}
        >
          {isUploading ? "アップロード中…" : "アップロード"}
        </button>

        <input
          type="file"
          className="hidden"
          ref={inputTypeFileReference}
          onChange={handleSelectCSVFile}
          onClick={(event) => (event.target.value = null)}
          disabled={isUploading}
        />
      </DefaultLayout>

      {isUploading && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
          <div className="bg-white rounded-lg px-8 py-6 shadow-lg text-center">
            <div className="mb-4 h-10 w-10 animate-spin rounded-full border-4 border-gray-300 border-t-black mx-auto" />
            <p className="text-lg font-semibold">CSVをアップロード中です</p>
            <p className="text-sm text-gray-600 mt-2">
              Niita分析は時間がかかりますので、しばらくお待ちください...
            </p>
          </div>
        </div>
      )}
    </>
  );
}

export default ExaminationResultUploadPage;
